import params from '../utils/params';
import {arrayBufferToBase64} from '../utils/tools';

export function getStreetViewPreview(longitude, latitude)
{
  return fetch("https://maps.googleapis.com/maps/api/streetview?size=1200x600&location=" + latitude + "," + longitude + "&fov=120&heading=235&pitch=10&key=" + params.GOOGLE_KEY)
  .then(response => {
    if (!response.ok) {
        throw (response);
    }
    return response;
  })
  .then(res=> {
    return res.arrayBuffer().then((buffer) => {
      var base64Flag = 'data:image/jpeg;base64,';
      var imageStr = arrayBufferToBase64(buffer);
      return base64Flag + imageStr;
    });
  })
  .catch((err)=>{
    return err;
  })
}



// WEBPACK FOOTER //
// ./src/api/google.js